import {SimpleTag} from "@atlaskit/tag";
import type {ComponentProps} from "react";

export function AnankeSimpleTag(props: ComponentProps<typeof SimpleTag>) {
    return (
        <div className="[&>span]:!cursor-[unset]">
            <SimpleTag {...props} />
        </div>
    );
}
